import React from "react";

export const IzenpeAuth = () => {
    return (
        <p>
            Redirección desde Izenpe
        </p>
    );
}